/**
 * Opens the browser print dialog ("Save as PDF") for the current view. The
 * page prints in the light theme whatever the viewer's preference, and the
 * document title — the browser's default PDF file name — is swapped for
 * `title` until the dialog closes.
 */
export const printPage = (title: string) => {
    const root = document.documentElement
    const theme = root.getAttribute('data-theme')
    const documentTitle = document.title
    root.setAttribute('data-theme', 'light')
    document.title = title
    window.addEventListener(
        'afterprint',
        () => {
            if (theme === null) root.removeAttribute('data-theme')
            else root.setAttribute('data-theme', theme)
            document.title = documentTitle
        },
        { once: true },
    )
    window.print()
}
